import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'
import { imageUrl } from 'app/frontend/base/helpers'
import { usePageInfo } from 'app/frontend/base/config/queries'
import { useTranslation } from 'react-i18next'
import { ChevronDown } from 'lucide-react'

const GameSwitcher = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const {
    data: { gameVersion },
  } = usePageInfo()

  const gameItem = (version: string) => {
    return (
      <a
        key={version}
        href={`http${location.host.includes('local') ? '' : 's'}://${
          {
            live: '',
            classic_era: 'vanilla.',
            classic_progression: 'classic.',
          }[version]
        }${location.host
          .replace('live.', '')
          .replace('classic.', '')
          .replace('vanilla.', '')}`}
      >
        <DropdownMenuItem className='flex gap-4 w-full pr-4'>
          <figure className='w-[6rem] h-[4rem]'>
            <img
              className='w-full h-full object-contain'
              src={imageUrl(
                `game-versions/${
                  {
                    live: 'war-within',
                    classic_era: 'vanilla-classic',
                    classic_progression: 'cataclysm-classic',
                  }[version]
                }-logo.png`,
              )}
            />
          </figure>

          <div
            className={`text-[1rem] leading-tight ${
              version === gameVersion ? 'text-primary' : ''
            }`}
          >
            {t(`game-versions.${version}.name`)}
          </div>
        </DropdownMenuItem>
      </a>
    )
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <span
          className={`flex gap-1 items-center cursor-pointer ${
            className ?? ''
          }`}
        >
          <span className='text-base'>
            {t(`game-versions.${gameVersion}.name`)}
          </span>
          <ChevronDown width={12} className='ml-0.5 mt-1 opacity-70' />
        </span>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {gameItem('live')}
        <DropdownMenuSeparator />
        {gameItem('classic_progression')}
        <DropdownMenuSeparator />
        {gameItem('classic_era')}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default GameSwitcher
